import parse from 'html-react-parser';
import React, { useCallback, useEffect, useState } from 'react';
import { strOracleApiSender } from '@/utils/stroracle-api-sender';
import { BouncingBox } from '@/widgets/bouncing-box-loader/bouncing-box-loader';
import { EmailPreviewError } from './email-preview-error';

export function LicenseEmailViewer({ licenseDeckardid }) {
  const [htmlString, setHtmlString] = useState();
  const [hasError, setHasError] = useState(false);

  const fetchLicenseHtml = useCallback(async () => {
    try {
      const { data } = await strOracleApiSender.get(
        `/licenses/${licenseDeckardid}/email_preview`,
        {},
        'text/html'
      );
      setHtmlString(data);
    } catch {
      setHasError(true);
    }
  }, [licenseDeckardid, setHasError, setHtmlString]);

  useEffect(() => {
    fetchLicenseHtml();
  }, [fetchLicenseHtml]);

  if (hasError) {
    return (
      <EmailPreviewError
        setHasError={setHasError}
        onTryAgainClick={fetchLicenseHtml}
      />
    );
  }

  if (!htmlString) {
    return (
      <div css="height: 600px;">
        <BouncingBox />
      </div>
    );
  }

  return <div css="width: 100%;">{parse(htmlString)}</div>;
}
